/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedHead_buyPage = {
    readonly meta: {
        readonly canonical: string | null;
        readonly disableIndexing: boolean | null;
        readonly prev: string | null;
        readonly " $fragmentRefs": FragmentRefs<"SharedHeadTitleTag_metadata" | "SharedHeadMetaTags_metadata" | "SharedHeadScriptTags_metadata" | "SharedHeadLinkTags_metadata">;
    } | null;
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly item: {
                readonly photos: ReadonlyArray<{
                    readonly versions: ReadonlyArray<{
                        readonly webPath: string | null;
                    } | null> | null;
                } | null> | null;
            } | null;
        } | null;
    } | null> | null;
    readonly " $refType": "BuySharedHead_buyPage";
};
export type BuySharedHead_buyPage$data = BuySharedHead_buyPage;
export type BuySharedHead_buyPage$key = {
    readonly " $data"?: BuySharedHead_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedHead_buyPage">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedHead_buyPage",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "meta",
      "storageKey": null,
      "args": null,
      "concreteType": "MetaData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "canonical",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "disableIndexing",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "prev",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SharedHeadTitleTag_metadata",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SharedHeadMetaTags_metadata",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SharedHeadScriptTags_metadata",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SharedHeadLinkTags_metadata",
          "args": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemSearchQueryEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemSearchResult",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "item",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "photos",
                  "storageKey": "photos(limit:1)",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "limit",
                      "value": 1
                    }
                  ],
                  "concreteType": "ItemPhoto",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "versions",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ItemPhotoVersion",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "webPath",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '1de081193b60c7a0babacbb6773bf83c';
export default node;
